import { View } from "@gluestack-ui/themed";
import { PreProposalScreens } from "@repo/core/screens/PreProposal";

const PreProposalsSelectFinancialServiceScreen = () => {
  return (
    <View flex={1} h="$full" w="$full">
      <PreProposalScreens.FinancialService />
    </View>
  );
};

export default PreProposalsSelectFinancialServiceScreen;
